import React, { Component } from "react"
import Button from "@material-ui/core/Button"
import FormControlLabel from "@material-ui/core/FormControlLabel"
import { Link } from "react-router-dom"
import Grid from "@material-ui/core/Grid"
import Typography from "@material-ui/core/Typography"
import Container from "@material-ui/core/Container"
import { withStyles } from "@material-ui/core"
import { Cookies } from "react-cookie"
import { Alert, AlertTitle } from "@material-ui/lab"
import { Redirect } from "react-router-dom"
import Paper from "@material-ui/core/Paper"
import Table from "@material-ui/core/Table"
import TableBody from "@material-ui/core/TableBody"
import TableCell from "@material-ui/core/TableCell"
import TableContainer from "@material-ui/core/TableContainer"
import TableHead from "@material-ui/core/TableHead"
import TablePagination from "@material-ui/core/TablePagination"
import TableRow from "@material-ui/core/TableRow"
import JDate from "jalali-date"
import Switch from "@material-ui/core/Switch"
import Snackbar from "@material-ui/core/Snackbar"
import * as constants from "../constants"
import Divider from "@material-ui/core/Divider"
import TableSortLabel from "@material-ui/core/TableSortLabel"
import Moment from "moment"
import NumberFormat from "react-number-format"
import HighlightOffIcon from "@material-ui/icons/HighlightOff"

import Collapse from "@material-ui/core/Collapse"
import Avatar from "@material-ui/core/Avatar"

import "react-modern-calendar-datepicker/lib/DatePicker.css"
import Calendar from "react-modern-calendar-datepicker"
import OutlinedInput from "@material-ui/core/OutlinedInput"
import IconButton from "@material-ui/core/IconButton"
import InputAdornment from "@material-ui/core/InputAdornment"
import FloatingLabelInput from "./FloatingLabelInput"
import Fab from "@material-ui/core/Fab"
import VoiceOverOffIcon from "@material-ui/icons/VoiceOverOff"
import RecordVoiceOverIcon from "@material-ui/icons/RecordVoiceOver"
import CloseIcon from "@material-ui/icons/Close"
import CheckIcon from "@material-ui/icons/Check"
import Select from "react-select"
import Dialog from "@material-ui/core/Dialog"
import DialogActions from "@material-ui/core/DialogActions"
import DialogContent from "@material-ui/core/DialogContent"
import DialogContentText from "@material-ui/core/DialogContentText"
import DialogTitle from "@material-ui/core/DialogTitle"
import ResponsdoctorsDamage from "./ResponsdoctorsDamage"
import ResponsdoctorsMedicspecialty from "./ResponsdoctorsMedicspecialty"
import ResponsdoctorsParaMedicspecialty from "./ResponsdoctorsParaMedicspecialty"
import AddIcon from "@material-ui/icons/Add"
import ResponseSupervisingEngineeringPriceFloor from "./ResponseSupervisingEngineeringPriceFloor";

const styles = (theme) => ({
      paperrtl: {
            marginTop: theme.spacing(0),
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
      },
      paper: {
            display: "flex",
            flexWrap: "wrap",
            "& > *": {
                  margin: theme.spacing(1),
                  width: theme.spacing(20),
            },
      },
      root: {
            width: "100%",
            margin: "15px",
            padding: "8px",
            direction: "rtl",
      },
      container: {
            maxHeight: 400,
      },
      large: {
            width: theme.spacing(10),
            height: theme.spacing(10),
      },
      small: {
            width: theme.spacing(6),
            height: theme.spacing(6),
      },
})

class ChangePriceResponsdoctors extends Component {
      cookies = new Cookies()
      temp333
      constructor(props) {
            super(props)
            this.state = {
                  redirect: false,
                  errstr: "",
                  errstatus: false,
                  okstatus: false,
                  requestinfos: [],
                  agentInfofilter: [],
                  rowsPerPage: 10,
                  page: 0,
                  response_supervising_engineer_price_id: "",
                  selectedCompany: { value: "", label: "", logo: "" },
                  response_supervising_engineer_price_deactive: "0",
                  company_logo_url: "",
                  orderBy: "response_supervising_engineer_price_id",
                  order: "desc",
                  snackstr: "",
                  showSnack: false,
                  snackMode: "success",
                  newPriceResponsdoctors: true,
                  optionCompany: [],
                  openDialog: false,
                  responsdoctorsDamage: [],
                  ResponseSupervisingEngineerFloor: [],
                  responseSupervisingEngineerFloorPrice: [],
                  responsdoctors_paramedic_price_damage_percent: "",
                  responsdoctors_price_damage_percent: "",
                  response_supervising_engineer_price_floor_calculator: "",
                  response_supervising_engineer_price_floor_viewer: "",
                  response_supervising_engineer_price_floor_designer: "",
                  responsdoctors_price_paramedic_price: "",
                  responsdoctors_price_paramedic_student: "",
                  responsdoctors_price_paramedic_aditionalcovarage: "",
                  selectedResponsdoctorsDamage: "",
                  selectedResponseSupervisingEngineerFloor: "",
                  selectedResponsdoctorsParaMedicspecialty: "",
            }
      }

      handleClickOpen = () => {
            this.setState({
                  openDialog: true,
            })
      }

      handleClose = () => {
            this.setState({
                  openDialog: false,
            })
      }

      handleCompany = (selectedCompany) => {
            this.setState({ selectedCompany: selectedCompany }, () => {
                  this.filterPriceResponsdoctors()
            })
      }

      handleClickcloseTasckBar = (event) => {
            this.setState({ showSnack: false })
      }

      handleChangeDeactive = (event) => {
            if (event.target.checked) {
                  this.setState({ response_supervising_engineer_price_deactive: "0" })
            } else {
                  this.setState({ response_supervising_engineer_price_deactive: "1" })
            }
      }

      handleResponsdoctorsDamage = (selectedResponsdoctorsDamage) => {
            this.setState({ selectedResponsdoctorsDamage: selectedResponsdoctorsDamage })
      }

      handleResponseSupervisingEngineerFloor = (selectedResponseSupervisingEngineerFloor) => {
            this.setState({ selectedResponseSupervisingEngineerFloor: selectedResponseSupervisingEngineerFloor })
      }

      handleResponsdoctorsParaMedicspecialty = (selectedResponsdoctorsParaMedicspecialty) => {
            this.setState({ selectedResponsdoctorsParaMedicspecialty: selectedResponsdoctorsParaMedicspecialty })
      }

      handleChangeExtrafinancialPrice = (event) => {
            this.setState({ responsdoctors_price_damage_percent: event })
      }

      handleChangeExtrafinancialParamedicPrice = (event) => {
            this.setState({ responsdoctors_paramedic_price_damage_percent: event })
      }

      handleChangeResponseSupervisingEngineerPriceFloorCalculator = (event) => {
            this.setState({ response_supervising_engineer_price_floor_calculator: event })
      }

      handleChangeResponseSupervisingEngineerPriceFloorViewer = (event) => {
            this.setState({ response_supervising_engineer_price_floor_viewer: event })
      }
      handleChangeResponseSupervisingEngineerPriceFloorDesigner = (event) => {
            this.setState({ response_supervising_engineer_price_floor_designer: event })
      }

      handleChangeResponsdoctorsParaMedicspecialty = (event) => {
            this.setState({ responsdoctors_price_paramedic_price: event })
      }

      handleChangeResponsdoctorsParaMedicStudent = (event) => {
            this.setState({ responsdoctors_price_paramedic_student: event })
      }

      handleChangeResponsdoctorsParaMedicAditionalcovarage = (event) => {
            this.setState({ responsdoctors_price_paramedic_aditionalcovarage: event })
      }
      handleSelectRows = (row2) => {
            // this.getpriceDamage(row2.response_supervising_engineer_price_id)
            // this.getResponseSupervisingEngineerFloor(row2.response_supervising_engineer_price_id)
            this.getresponseSupervisingFloorPrice(row2.response_supervising_engineer_price_id)
            this.setState(
                  {
                        response_supervising_engineer_price_id: row2.response_supervising_engineer_price_id,

                        selectedCompany: { value: row2.response_supervising_engineer_price_fieldcompany_id, label: row2.company_name, logo: row2.company_logo_url },

                        response_supervising_engineer_price_deactive: row2.response_supervising_engineer_price_deactive,
                        company_logo_url: row2.company_logo_url,
                        newPriceResponsdoctors: false,
                  },
                  () => {}
            )
      }

      newPriceResponsdoctors = (event) => {
            this.setState({
                  response_supervising_engineer_price_id: "",
                  selectedCompany: { value: "", label: "", logo: "" },
                  selectedKind: "",
                  response_supervising_engineer_price_deactive: "0",
                  company_logo_url: "",
                  newPriceResponsdoctors: true,
            })
      }
      componentDidMount() {
            if (this.cookies.get("employee_token_str")) {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              if (arr.result === "ok") {
                                    self.getPriceResponseSupervisingEngineer()
                                    self.getoptionCompany()
                                    // self.getoptionResponsdoctorsDamage()
                                    self.getoptionResponseSupervisingEngineerFloor()
                                    // self.getoptionResponsdoctorsParaMedicspecialty()
                              } else if (arr.result === "error") {
                                    self.setState({ redirect: true })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "checkemployeelogin")

                  xhttp.open("POST", `${constants.BASE_URL}/employeelogin`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ redirect: true })
            }
      }

      deleteManagdiscount = () => {
            const { response_supervising_engineer_price_id } = this.state
            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            })
            this.handleClose()
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                              //self.setState({ redirect: true })
                              self.getPriceResponseSupervisingEngineer()
                              self.newPriceResponsdoctors()
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                        self.props.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "delete_response_supervising_engineer_price")
            fd.append("response_supervising_engineer_price_id", response_supervising_engineer_price_id)

            xhttp.open("POST", `${constants.BASE_URL}/ResponseSupervisingEngineer`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      getPriceResponseSupervisingEngineer() {
            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            })
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        console.log(this.responseText)
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              self.setState({ requestinfos: arr.data, agentInfofilter: arr.data }, () => {})
                        } else if (arr.result === "error") {
                        }
                        self.props.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_response_supervising_engineer_price")
            xhttp.open("POST", `${constants.BASE_URL}/ResponseSupervisingEngineer`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      getpriceDamage(response_supervising_engineer_price_id) {
            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            })
            this.setState({ responsdoctorsDamage: [] }, () => {
                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              if (arr.result === "ok") {
                                    self.setState({ responsdoctorsDamage: arr.data }, () => {})
                              } else if (arr.result === "error") {
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "get_price_damage")
                  fd.append("response_supervising_engineer_price_id", response_supervising_engineer_price_id)

                  xhttp.open("POST", `${constants.BASE_URL}/responsdoctors`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            })
      }

      getResponseSupervisingEngineerFloor(response_supervising_engineer_price_id) {
            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            })
            this.setState({ ResponseSupervisingEngineerFloor: [] }, () => {
                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              console.log(arr)
                              if (arr.result === "ok") {
                                    self.setState({ ResponseSupervisingEngineerFloor: arr.data }, () => {})
                              } else if (arr.result === "error") {
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "get_price_medic_tb")
                  fd.append("response_supervising_engineer_price_id", response_supervising_engineer_price_id)

                  xhttp.open("POST", `${constants.BASE_URL}/responsdoctors`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            })
      }

      getresponseSupervisingFloorPrice(response_supervising_engineer_price_id) {
            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            })
            this.setState({ responseSupervisingEngineerFloorPrice: [] }, () => {
                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              console.log(arr)
                              if (arr.result === "ok") {
                                    self.setState({ responseSupervisingEngineerFloorPrice: arr.data }, () => {})
                              } else if (arr.result === "error") {
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "get_RSE_price_floor")
                  fd.append("response_supervising_engineer_price_floor_RSE_price_id", response_supervising_engineer_price_id)

                  xhttp.open("POST", `${constants.BASE_URL}/ResponseSupervisingEngineer`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            })
      }

      getoptionCompany = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({
                                          value: arr.data[k].fieldcompany_id,
                                          label: arr.data[k].company_name,
                                          logo: arr.data[k].company_logo_url,
                                    })
                              }
                              self.setState({ optionCompany: Company, selectedCompany: Company[0] }, () => {
                                    self.filterPriceResponsdoctors()
                              })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_fieldcompany")
            fd.append("fieldinsurance", "responseSupervisingEngineer")
            xhttp.open("POST", `${constants.BASE_URL}/fieldcompany`)
            xhttp.send(fd)
      }

      getoptionResponsdoctorsDamage = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        console.log(this.responseText)
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({ value: arr.data[k].responsdoctors_damage_id, label: arr.data[k].responsdoctors_damage_name })
                              }
                              self.setState({ optionResponsdoctorsDamage: Company }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_responsdoctors_damage")
            xhttp.open("POST", `${constants.BASE_URL}/responsdoctors`)
            xhttp.send(fd)
      }

      getoptionResponseSupervisingEngineerFloor = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({
                                          value: arr.data[k].response_supervising_engineer_floor_id,
                                          label: arr.data[k].response_supervising_engineer_floor_name,
                                    })
                              }
                              self.setState({ optionResponseSupervisingEngineerFloor: Company }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_response_supervising_engineer_floor")
            xhttp.open("POST", `${constants.BASE_URL}/ResponseSupervisingEngineer`)
            xhttp.send(fd)
      }

      getoptionResponsdoctorsParaMedicspecialty = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({
                                          value: arr.data[k].responsdoctors_paramedicspecialty_id,
                                          label: arr.data[k].responsdoctors_paramedicspecialty_name,
                                    })
                              }
                              self.setState({ optionResponsdoctorsParaMedicspecialty: Company }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_responsdoctors_paramedicspecialty")
            xhttp.open("POST", `${constants.BASE_URL}/responsdoctors`)
            xhttp.send(fd)
      }

      saveNewPriceResponseSupervisingEngineer = () => {
            const {
                  selectedCompany,
                  response_supervising_engineer_price_deactive,
            } = this.state
            if (
                  selectedCompany != ""
            ) {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              if (arr.result === "ok") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                                    //self.setState({ redirect: true })
                                    self.getPriceResponseSupervisingEngineer()
                              } else if (arr.result === "error") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "add_response_supervising_engineer_price")

                  fd.append("response_supervising_engineer_price_fieldcompany_id", selectedCompany.value)
                  fd.append("response_supervising_engineer_price_deactive", response_supervising_engineer_price_deactive)

                  xhttp.open("POST", `${constants.BASE_URL}/ResponseSupervisingEngineer`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ snackstr: "لطفا مشخصات قیمت شرکت بیمه را وارد نمایید", showSnack: true, snackMode: "error" })
            }
      }

      saveNewPriceResponsdoctorsDamage = () => {
            const { response_supervising_engineer_price_id, selectedResponsdoctorsDamage, responsdoctors_price_damage_percent, responsdoctors_paramedic_price_damage_percent } = this.state
            if (selectedResponsdoctorsDamage != "" && responsdoctors_price_damage_percent != ""&& responsdoctors_paramedic_price_damage_percent != "") {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              if (arr.result === "ok") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                                    self.setState({ responsdoctors_price_damage_percent: "", responsdoctors_paramedic_price_damage_percent: "",selectedResponsdoctorsDamage: "" })
                                    self.getpriceDamage(response_supervising_engineer_price_id)
                              } else if (arr.result === "error") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "add_price_damage")
                  fd.append("responsdoctors_price_damage_responsdoctors_price_id", response_supervising_engineer_price_id)
                  fd.append("responsdoctors_price_damage_percent", responsdoctors_price_damage_percent)
                  fd.append("responsdoctors_paramedic_price_damage_percent", responsdoctors_paramedic_price_damage_percent)
                  fd.append("responsdoctors_price_damage_responsdoctors_damage_id", selectedResponsdoctorsDamage.value)

                  xhttp.open("POST", `${constants.BASE_URL}/responsdoctors`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ snackstr: "لطفا مشخصات درصد پوشش را وارد نمایید", showSnack: true, snackMode: "error" })
            }
      }

      saveNewPriceResponseSupervisingEngineerFloor = () => {
            const {
                  response_supervising_engineer_price_id,
                  selectedResponseSupervisingEngineerFloor,
                  response_supervising_engineer_price_floor_calculator,
                  response_supervising_engineer_price_floor_viewer,
                  response_supervising_engineer_price_floor_designer,
            } = this.state
            if (
                  selectedResponseSupervisingEngineerFloor != "" &&
                  response_supervising_engineer_price_floor_calculator != "" &&
                  response_supervising_engineer_price_floor_viewer != "" &&
                  response_supervising_engineer_price_floor_designer != ""
            ) {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              console.log(this.responseText)
                              var arr = JSON.parse(this.responseText)
                              console.log(arr)
                              if (arr.result === "ok") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                                    self.setState({
                                          response_supervising_engineer_price_floor_calculator: "",
                                          response_supervising_engineer_price_floor_viewer: "",
                                          response_supervising_engineer_price_floor_designer: "",
                                          selectedResponseSupervisingEngineerFloor: "",
                                    })
                                    // self.getResponseSupervisingEngineerFloor(response_supervising_engineer_price_id)
                                    self.getresponseSupervisingFloorPrice(response_supervising_engineer_price_id)
                              } else if (arr.result === "error") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "add_RSE_price_floor")
                  fd.append("response_supervising_engineer_price_floor_RSE_price_id", response_supervising_engineer_price_id)
                  fd.append("response_supervising_engineer_price_floor_calculator", response_supervising_engineer_price_floor_calculator)
                  fd.append("response_supervising_engineer_price_floor_viewer", response_supervising_engineer_price_floor_viewer)
                  fd.append("response_supervising_engineer_price_floor_designer", response_supervising_engineer_price_floor_designer)
                  fd.append("response_supervising_engineer_price_floor_RSE_floor_id", selectedResponseSupervisingEngineerFloor.value)

                  xhttp.open("POST", `${constants.BASE_URL}/ResponseSupervisingEngineer`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ snackstr: "لطفا مشخصات درصد زمان بیمه را وارد نمایید", showSnack: true, snackMode: "error" })
            }
      }

      saveNewPriceResponsdoctorsParaMedicspecialty = () => {
            const {
                  response_supervising_engineer_price_id,
                  selectedResponsdoctorsParaMedicspecialty,
                  responsdoctors_price_paramedic_price,
                  responsdoctors_price_paramedic_student,
                  responsdoctors_price_paramedic_aditionalcovarage,
            } = this.state
            if (
                  selectedResponsdoctorsParaMedicspecialty != "" &&
                  responsdoctors_price_paramedic_price != "" &&
                  responsdoctors_price_paramedic_student != "" &&
                  responsdoctors_price_paramedic_aditionalcovarage != ""
            ) {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              console.log(this.responseText)
                              var arr = JSON.parse(this.responseText)
                              console.log(arr)
                              if (arr.result === "ok") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                                    self.setState({
                                          responsdoctors_price_paramedic_price: "",
                                          responsdoctors_price_paramedic_student: "",
                                          responsdoctors_price_paramedic_aditionalcovarage: "",
                                          selectedResponsdoctorsParaMedicspecialty: "",
                                    })
                                    // self.getResponseSupervisingEngineerFloor(response_supervising_engineer_price_id)
                                    self.getresponseSupervisingFloorPrice(response_supervising_engineer_price_id)
                              } else if (arr.result === "error") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "add_price_paramedic_tb")
                  fd.append("responsdoctors_price_paramedic_responsdoctors_price_id", response_supervising_engineer_price_id)
                  fd.append("responsdoctors_price_paramedic_price", responsdoctors_price_paramedic_price)
                  fd.append("responsdoctors_price_paramedic_student", responsdoctors_price_paramedic_student)
                  fd.append("responsdoctors_price_paramedic_aditionalcovarage", responsdoctors_price_paramedic_aditionalcovarage)
                  fd.append("responsdoctors_price_paramedic_responsdoctors_paramedic_id", selectedResponsdoctorsParaMedicspecialty.value)

                  xhttp.open("POST", `${constants.BASE_URL}/responsdoctors`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ snackstr: "لطفا مشخصات درصد زمان بیمه را وارد نمایید", showSnack: true, snackMode: "error" })
            }
      }

      changePriceResponsdoctors = () => {
            const {
                  response_supervising_engineer_price_id,
                  selectedCompany,
                  response_supervising_engineer_price_deactive,
            } = this.state
            if (
                  selectedCompany != ""
            ) {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              if (arr.result === "ok") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                                    //self.setState({ redirect: true })
                                    self.getPriceResponseSupervisingEngineer()
                              } else if (arr.result === "error") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "modify_responsdoctors_price")
                  fd.append("response_supervising_engineer_price_id", response_supervising_engineer_price_id)

                  fd.append("response_supervising_engineer_price_fieldcompany_id", selectedCompany.value)
                  fd.append("response_supervising_engineer_price_deactive", response_supervising_engineer_price_deactive)

                  xhttp.open("POST", `${constants.BASE_URL}/responsdoctors`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ snackstr: "لطفا مشخصات قیمت شرکت بیمه را وارد نمایید", showSnack: true, snackMode: "error" })
            }
      }

      createSortHandler = (field) => {
            if (this.state.orderBy === field) {
                  if (this.state.order === "asc") {
                        this.setState({ order: "desc" })
                  } else {
                        this.setState({ order: "asc" })
                  }
            } else {
                  this.setState({ orderBy: field, order: "asc" })
            }
            var arraytemp = [],
                  i,
                  j,
                  temp,
                  a,
                  b
            arraytemp = this.state.agentInfofilter
            for (i = 0; i < arraytemp.length; i++) {
                  for (j = 0; j < arraytemp.length - 1; j++) {
                        a = arraytemp[j]
                        b = arraytemp[j + 1]
                        if (a[field] < b[field] && this.state.order === "asc") {
                              temp = arraytemp[j]
                              arraytemp[j] = arraytemp[j + 1]
                              arraytemp[j + 1] = temp
                        } else if (a[field] > b[field] && this.state.order === "desc") {
                              temp = arraytemp[j]
                              arraytemp[j] = arraytemp[j + 1]
                              arraytemp[j + 1] = temp
                        }
                  }
            }
      }

      handleChangeRowsPerPage = (event) => {
            this.setState({ rowsPerPage: parseInt(event.target.value), page: 0 })
      }

      handleChangePage = (event, number) => {
            this.setState({ page: parseInt(number, 0) })
      }
      filterPriceResponsdoctors = () => {
            const { selectedCompany, requestinfos } = this.state
            var temparray = requestinfos,
                  temparray2 = [],
                  i
            for (i = 0; i < temparray.length; i++) {
                  if (selectedCompany.value === 0 || temparray[i].response_supervising_engineer_price_fieldcompany_id === selectedCompany.value) {
                        temparray2.push(temparray[i])
                  }
            }
            this.setState({ agentInfofilter: temparray2 }, () => {})
      }

      render() {
            const { classes } = this.props
            const {
                  responsdoctors_price_damage_percent,
                  responsdoctors_paramedic_price_damage_percent,
                  responsdoctors_price_paramedic_price,
                  responsdoctors_price_paramedic_student,
                  responsdoctors_price_paramedic_aditionalcovarage,
                  response_supervising_engineer_price_floor_calculator,
                  response_supervising_engineer_price_floor_viewer,
                  response_supervising_engineer_price_floor_designer,
                  selectedResponsdoctorsDamage,
                  selectedResponseSupervisingEngineerFloor,
                  selectedResponsdoctorsParaMedicspecialty,
                  optionCompany,
                  optionResponsdoctorsDamage,
                  optionResponseSupervisingEngineerFloor,
                  optionResponsdoctorsParaMedicspecialty,
                  responsdoctorsDamage,
                  ResponseSupervisingEngineerFloor,
                  responseSupervisingEngineerFloorPrice,
                  snackMode,
                  snackstr,
                  showSnack,
                  newPriceResponsdoctors,
                  response_supervising_engineer_price_id,
                  company_logo_url,
                  selectedCompany,
                  response_supervising_engineer_price_deactive,
                  order,
                  orderBy,
                  okstatus,
                  errstr,
                  redirect,
                  agentInfofilter,
                  rowsPerPage,
                  page,
            } = this.state
            if (redirect) {
                  return <Redirect to="/" />
            } else {
                  return (
                        <div className={classes.paperrtl} dir="ltr">
                              <Snackbar
                                    anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                                    onClose={this.handleClickcloseTasckBar}
                                    open={showSnack}
                                    autoHideDuration={10000}
                              >
                                    <Alert severity={snackMode}>{snackstr}</Alert>
                              </Snackbar>
                              <Grid container spacing={3}>
                                    <Grid item xs={12}>
                                          <Container component="main" maxWidth="lg">
                                                <Paper elevation={4} className={classes.root}>
                                                      <Grid container spacing={3}>
                                                            <Grid item xs={6}>
                                                                  <Typography align="center" variant="h7">
                                                                        {"شماره قیمت بیمه مسئولیت مهندس ناظر: " + response_supervising_engineer_price_id}
                                                                  </Typography>
                                                            </Grid>
                                                            <Grid item xs={6}></Grid>

                                                            <Grid item xs={6}></Grid>

                                                            <Grid item xs={6}>
                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <img alt="" className={classes.large} src={selectedCompany.logo} />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <div>
                                                                        <label className="on">شرکت بیمه</label>
                                                                        <Select
                                                                              isSearchable={true}
                                                                              className="adapter-txtsize"
                                                                              placeholder={"شرکت بیمه"}
                                                                              value={selectedCompany}
                                                                              onChange={this.handleCompany}
                                                                              options={optionCompany}
                                                                        />
                                                                  </div>
                                                            </Grid>


                                                            <Grid item xs={6}>
                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <FormControlLabel
                                                                              control={
                                                                                    <Switch
                                                                                          checked={
                                                                                                response_supervising_engineer_price_deactive === "0" ? true : false
                                                                                          }
                                                                                          onChange={this.handleChangeDeactive}
                                                                                          name="gilad"
                                                                                    />
                                                                              }
                                                                              label="وضعیت قیمت شرکت بیمه"
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={12}>
                                                                  {newPriceResponsdoctors ? (
                                                                        <Button
                                                                              variant="outlined"
                                                                              color="primary"
                                                                              onClick={this.saveNewPriceResponseSupervisingEngineer}
                                                                        >
                                                                              {"ثبت قیمت بیمه مسئولیت مهندس ناظر جدید "}
                                                                        </Button>
                                                                  ) : (
                                                                        <div style={{ width: "100%", textAlign: "right" }}>
                                                                              <Button
                                                                                    variant="outlined"
                                                                                    color="primary"
                                                                                    onClick={this.newPriceResponsdoctors}
                                                                              >
                                                                                    {"قیمت بیمه مسئولیت مهندس ناظر جدید "}
                                                                              </Button>
                                                                              {"          "}
                                                                              <Button
                                                                                    variant="outlined"
                                                                                    color="primary"
                                                                                    onClick={this.changePriceResponsdoctors}
                                                                              >
                                                                                    {"ثبت تغییرات"}
                                                                              </Button>
                                                                              {"          "}
                                                                              <Button
                                                                                    variant="outlined"
                                                                                    color="primary"
                                                                                    onClick={(e) => {
                                                                                          this.handleClickOpen()
                                                                                    }}
                                                                              >
                                                                                    {" حذف قیمت بیمه مسئولیت مهندس ناظر"}
                                                                              </Button>
                                                                        </div>
                                                                  )}
                                                            </Grid>

                                                            {newPriceResponsdoctors ? null : (
                                                                  <Grid item xs={12}>
                                                                        <Divider />
                                                                  </Grid>
                                                            )}
                                                      </Grid>
                                                </Paper>
                                          </Container>
                                    </Grid>


                                    <Grid item xs={12}>
                                          <Container>
                                                <Paper style={{ backgroundColor: "#cfe8fc" }} className={classes.root}>
                                                      {newPriceResponsdoctors ? null : (
                                                            <Grid item xs={12} style={{ backgroundColor: "#cfe8fc" }}>
                                                                  {responseSupervisingEngineerFloorPrice.map((responseSupervisingEngineerFloorPrice, index) => (
                                                                        <ResponseSupervisingEngineeringPriceFloor
                                                                            responseSupervisingEngineerFloorPrice={responseSupervisingEngineerFloorPrice}
                                                                              props={this.props}
                                                                              key={index}
                                                                        />
                                                                  ))}
                                                            </Grid>
                                                      )}
                                                </Paper>
                                                <Paper className={classes.root}>
                                                      {newPriceResponsdoctors ? null : (
                                                            <Grid item xs={12}>
                                                                  <Grid container spacing={3}>
                                                                        <Grid item xs={3}>
                                                                              <div>
                                                                                    <label className="on">طبقه </label>
                                                                                    <Select
                                                                                          isSearchable={true}
                                                                                          className="adapter-txtsize"
                                                                                          placeholder={"طبقه"}
                                                                                          value={selectedResponseSupervisingEngineerFloor}
                                                                                          onChange={this.handleResponseSupervisingEngineerFloor}
                                                                                          options={optionResponseSupervisingEngineerFloor}
                                                                                    />
                                                                              </div>
                                                                        </Grid>

                                                                        <Grid item item xs={2}>
                                                                              <FloatingLabelInput
                                                                                    type="currency"
                                                                                    placeholder="قیمت محاسب"
                                                                                    handleInputt={this.handleChangeResponseSupervisingEngineerPriceFloorCalculator}
                                                                                    value={response_supervising_engineer_price_floor_calculator}
                                                                              />
                                                                        </Grid>

                                                                        <Grid item item xs={2}>
                                                                              <FloatingLabelInput
                                                                                    type="currency"
                                                                                    placeholder="قیمت  ناظر"
                                                                                    handleInputt={this.handleChangeResponseSupervisingEngineerPriceFloorViewer}
                                                                                    value={response_supervising_engineer_price_floor_viewer}
                                                                              />
                                                                        </Grid>

                                                                        <Grid item item xs={2}>
                                                                              <FloatingLabelInput
                                                                                  type="currency"
                                                                                  placeholder="قیمت طراح"
                                                                                  handleInputt={this.handleChangeResponseSupervisingEngineerPriceFloorDesigner}
                                                                                  value={response_supervising_engineer_price_floor_designer}
                                                                              />
                                                                        </Grid>


                                                                        <Grid item item xs={1}>
                                                                              <div style={{ width: "100%", textAlign: "left" }}>
                                                                                    <Fab
                                                                                          className={classes.small}
                                                                                          color="primary"
                                                                                          aria-label="add"
                                                                                          onClick={this.saveNewPriceResponseSupervisingEngineerFloor}
                                                                                    >
                                                                                          <AddIcon />
                                                                                    </Fab>
                                                                              </div>
                                                                        </Grid>
                                                                  </Grid>
                                                            </Grid>
                                                      )}
                                                </Paper>
                                          </Container>
                                    </Grid>


                                    <Grid item xs={12}>
                                          <Container maxWidth="lg">
                                                <Paper className={classes.root}>
                                                      <TableContainer dir="rtl">
                                                            <Table aria-label="sticky table">
                                                                  <TableHead>
                                                                        <TableRow>
                                                                              <TableCell
                                                                                    key={"response_supervising_engineer_price_id"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 20 }}
                                                                                    sortDirection={
                                                                                          orderBy === "response_supervising_engineer_price_id" ? order : false
                                                                                    }
                                                                              >
                                                                                    {" آی دی قیمت"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "response_supervising_engineer_price_id"}
                                                                                          direction={
                                                                                                orderBy === "response_supervising_engineer_price_id" ? order : "asc"
                                                                                          }
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("response_supervising_engineer_price_id")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"company_name"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"شرکت بیمه  "}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "company_name"}
                                                                                          direction={orderBy === "company_name" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("company_name")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>


                                                                              <TableCell
                                                                                    key={"response_supervising_engineer_price_deactive"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 20 }}
                                                                              >
                                                                                    {"وضعیت قیمت بیمه مسئولیت مهندس ناظر"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "response_supervising_engineer_price_deactive"}
                                                                                          direction={
                                                                                                orderBy === "response_supervising_engineer_price_deactive"
                                                                                                      ? order
                                                                                                      : "asc"
                                                                                          }
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler(
                                                                                                      "response_supervising_engineer_price_deactive"
                                                                                                )
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>
                                                                        </TableRow>
                                                                  </TableHead>

                                                                  <TableBody>
                                                                        {agentInfofilter
                                                                              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                                              .map((row) => {
                                                                                    return (
                                                                                          <TableRow
                                                                                                hover
                                                                                                role="checkbox"
                                                                                                tabIndex={-1}
                                                                                                key={row["response_supervising_engineer_price_id"]}
                                                                                                value={row}
                                                                                                onClick={() => {
                                                                                                      this.handleSelectRows(row)
                                                                                                }}
                                                                                          >
                                                                                                <TableCell
                                                                                                      key={"response_supervising_engineer_price_id"}
                                                                                                      align={"center"}
                                                                                                >
                                                                                                      {row["response_supervising_engineer_price_id"]}
                                                                                                </TableCell>

                                                                                                <TableCell key={"company_name"} align={"center"}>
                                                                                                      {row["company_name"]}
                                                                                                      <img
                                                                                                            className={classes.small}
                                                                                                            alt="Remy Sharp"
                                                                                                            src={row["company_logo_url"]}
                                                                                                      />
                                                                                                </TableCell>



                                                                                                <TableCell
                                                                                                      key={"response_supervising_engineer_price_deactive"}
                                                                                                      align={"center"}
                                                                                                >
                                                                                                      {row["response_supervising_engineer_price_deactive"] === "1" ||
                                                                                                      row["response_supervising_engineer_price_deactive"] === 1 ? (
                                                                                                            <Fab variant="extended">
                                                                                                                  <VoiceOverOffIcon />
                                                                                                                  {"غیر فعال"}
                                                                                                            </Fab>
                                                                                                      ) : (
                                                                                                            <Fab
                                                                                                                  variant="extended"
                                                                                                                  style={{ background: "#44b700" }}
                                                                                                            >
                                                                                                                  <RecordVoiceOverIcon />
                                                                                                                  {"فعال"}
                                                                                                            </Fab>
                                                                                                      )}
                                                                                                </TableCell>
                                                                                          </TableRow>
                                                                                    )
                                                                              })}
                                                                  </TableBody>
                                                            </Table>
                                                      </TableContainer>
                                                      <TablePagination
                                                            rowsPerPageOptions={[10, 25, 100]}
                                                            component="div"
                                                            count={agentInfofilter.length}
                                                            rowsPerPage={rowsPerPage}
                                                            page={page}
                                                            onChangePage={this.handleChangePage}
                                                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                                      />
                                                </Paper>
                                          </Container>
                                    </Grid>
                              </Grid>

                              {okstatus ? (
                                    <Alert severity="success">
                                          <AlertTitle>پیام</AlertTitle>
                                          {errstr}
                                    </Alert>
                              ) : null}
                              <Dialog
                                    open={this.state.openDialog}
                                    onClose={this.handleClose}
                                    aria-labelledby="alert-dialog-title"
                                    aria-describedby="alert-dialog-description"
                              >
                                    <DialogTitle id="alert-dialog-title">{"آیا میخواهید قیمت بیمه مسئولیت مهندس ناظر را حذف نمایید"}</DialogTitle>
                                    <DialogContent>
                                          <DialogContentText id="alert-dialog-description">
                                                ابتدا از عملیات خود مطمئن شوید و سپس پاک کنید
                                          </DialogContentText>
                                    </DialogContent>
                                    <DialogActions>
                                          <Button onClick={this.handleClose} color="primary">
                                                انصراف
                                          </Button>
                                          <Button onClick={this.deleteManagdiscount} color="primary" autoFocus>
                                                بله انجام شود
                                          </Button>
                                    </DialogActions>
                              </Dialog>
                        </div>
                  )
            }
      }
}

export default withStyles(styles)(ChangePriceResponsdoctors)
